export default __webpack_public_path__ + "static/media/Oracle_NetSuite_Logo.a52e9867.png";